import React, { useEffect, useState } from "react";
import "../../Completed/QuestionCompleted/QuestionType.css";
import ImgType from "./ImgType";
import TextareaType from "./TextareaType";
import PdfType from "./PdfType";
import VideoType from "./VideoType";
import CheckBoxType from "./CheckBoxType";
import SubmisshionByUpload from "./SubmisshionByUpload";
import { useSelector } from "react-redux";
import axios from "../../../../axios";
import { useParams, useLocation } from "react-router-dom";
import VerticalProgBar from "../../Pending/VarticalProgressBar/VerticalProgBar";
import AdaptiveEvalutionGraph from "./AdaptiveEvalutionGraph";
// import { assessmentTimeHelper, assessmentDateHelper } from "../../../../utils/datetime_helper";


export default function AllQuestions({
  assessmentId: propAssessmentId,
  handleViewAnswerQuestionFalse,
  FromSummaryUpdate,
  completeAss
}) {
  const { state } = useLocation()
  const { assessmentId: paramsAssessmentId } = useParams();
  const assessmentId = propAssessmentId || paramsAssessmentId;
  const [resultData, setResultData] = useState([]);
  const [isGettingData, setIsGettingData] = useState(true);
  const userId = useSelector((state) => state.user?.currentUser?.id);
  const [studentResultData, setStudentResultData] = useState([])
  const [openGraphPopup, setOpenGraphPopup] = useState(false)
  const [studentMarksDetails, setStudentMarksDetails] = useState([])
  const [questionNo, setQuestionNo] = useState(0);
  const [skillsValue, setSkillsValue] = useState(0);
  const [chartData, setChartData] = useState()

  useEffect(() => {
    getStudentResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentId, userId]);
  const getStudentResponse = async () => {
    try {
      let res = await axios.get(
        `/assessment/${assessmentId}/studentResult/student/${userId}/get`
      );
      if (res) {
        let resultes = res?.data?.data?.results;
        setResultData(resultes);
        setStudentResultData(res.data.data)
        let qsNoLabels = []

        if (res.data.data.assessment.isAdaptive) {
          const resultArray = resultes.map((curr, index) => {

            const resultObj = {
              questionNumber: `Q${index + 1}`,
            };

            // Populate separate arrays if needed
            qsNoLabels.push(resultObj.questionNumber);

            return resultObj;
          });
          setChartData(resultArray)
        }
      }
      setIsGettingData(false);
    } catch (error) {
      setIsGettingData(false);
      console.log(error);
    }
  };

  const [allQuestion, setAllQuestion] = useState({
    sucessful: false,
  });

  useEffect(() => {
    const getStudentMarksDetails = async () => {
      try {
        const res = await axios.get(
          `/assessment/${assessmentId}/studentScoreBoard/get/studentId/${userId}`
        );
        console.log("resScoreBoard", res)
        res && setStudentMarksDetails(res?.data?.data)
        setIsGettingData(false);
      } catch (error) {
        setIsGettingData(false);
        console.log("error", error)
      }
    }
    getStudentMarksDetails()
  }, [])


  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };
  const [difficulty, setDifficulty] = useState(0);
  // const [skills, setSkills] = useState(0);

  const difficultyLevels = ["Very Hard", "Hard", "Medium", "Easy", "Very Easy"];
  const skillsLevels = ["Create", "Evalute", "Analyze", "Apply", "Understand", "Remember"];

  // const list = [
  //   {
  //     type: "Checkbox Type",
  //   },

  //   {
  //     type: "Img Type",
  //   },
  //   {
  //     type: "Video Type",
  //   },
  //   {
  //     type: "Pdf Type",
  //   },
  //   {
  //     type: "TextArea Type",
  //   },
  //   {
  //     type: "Upload Type",
  //   },
  // ];


  useEffect(() => {
    if (resultData.length > 0) {
      getDifficultyName(resultData);
    }
  }, [questionNo, resultData]);

  const getDifficultyName = (resultes) => {
    const questionTypeMap = {
      "Very Easy": 1,
      "Easy": 2,
      "Medium": 3,
      "Difficult": 4,
      "Very Difficult": 5,
    };
    const questionTypeMapSkill = {
      "Create": 6,
      "Evaluate": 5,
      "Analyze": 4,
      "Apply": 3,
      "Understand": 2,
      "Remember": 1,
    };
    let currectQues = [];
    for (let i = 0; i < resultes.length; i++) {
      if (questionNo === i) {
        currectQues.push(resultes[i])
      }
    }
    const difficultyValue = questionTypeMap[currectQues[0]?.question_response?.question?.difficulty_level?.name] || 0;
    const skillsValue = questionTypeMapSkill[currectQues[0]?.question_response?.question?.skill?.name] || 0;
    setDifficulty(difficultyValue);
    console.log("skillsValue", skillsValue)
    setSkillsValue(skillsValue);
  }

  const showSummary = {
    background: "#F77F00",
    fontSize: "16px",
    padding: "11px 14px",
    fontWeight: "600",
    borderRadius: "5px",
    border: "none",
    color: '#fff'
  }

  const handleRouteBack = () => {
    if (FromSummaryUpdate === 'FromSummaryUpdate') {
      window.history.back()
    } else {
      handleViewAnswerQuestionFalse()
    }
  }

  return (
    <>
      {
        isGettingData ? (
          <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
            <img
              className="ongoing_internal_loader"
              src="/gif/LoaderDot.gif"
              alt=""
            />
          </div>) :
          (studentResultData.length !== 0) ? (
            <div className="ContainerQuestion d-flex p-4 gap-1">
              <div>
                <img
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleRouteBack()
                  }}
                  src="/HwImg/backArrow.png"
                  alt=""
                />{" "}
                &nbsp;
              </div>
              <div className="hederContainer1">
                <div>
                  <div className="d-flex justify-content-between w-100 mb-1">
                    <div className="d-flex">
                      <div className="quesHeading">
                        {studentResultData?.assessment?.name}
                      </div>
                      <div className="penddingButton ml-2">Completed</div>
                    </div>
                    <div>
                      <div>
                        {
                          studentResultData.assessment.isAdaptive && (
                            <>
                              <span className="subTitles">
                                <button style={showSummary} onClick={() => setOpenGraphPopup(true)}>Show Summary</button>
                              </span>
                            </>
                          )
                        }
                        {
                          studentResultData.assessment.isAdaptive ? null :
                            <>
                              <span className="subTitles">Result</span>&nbsp;
                              <span className="quesHeading">
                                {studentResultData?.obtained_marks}/
                                {studentResultData?.assessment?.total_marks}
                              </span>
                              <div className="quesHeading d-flex justify-content-start">
                                <span className="subTitles">Question No.</span> &nbsp;
                                {questionNo + 1}/{resultData?.length}
                              </div>
                              <div>
                                <span className="subTitles">Total Marks</span> &nbsp;
                                <span className="quesHeading">
                                  {studentResultData?.obtained_marks} out of{" "}
                                  {studentResultData?.assessment?.total_marks}
                                </span>
                              </div>
                              <div>
                                <span className="subTitles">This Question Marks</span>{" "}
                                &nbsp;
                                <span className="quesHeading">
                                  {resultData[questionNo]?.obtained_marks} out of{" "}
                                  {
                                    resultData[questionNo]?.question_response?.question
                                      ?.correct_score
                                  }
                                </span>
                              </div>
                            </>
                        }
                      </div>
                    </div>
                    {/* <div>
                  <div>
                    <span className="subTitles">Total Marks</span> &nbsp;
                    <span className="quesHeading">
                      {studentResult?.obtained_marks}/
                      {studentResult?.assessment?.total_marks}
                    </span>
                  </div>
                  <div style={{textAlign:"end"}}>
                    &nbsp; <span className="subTitles">This Question</span>{" "}
                    &nbsp;
                    <span className="quesHeading"> */}
                    {/* {studentResult?.assessment?.total_questions.toString().padStart(2, '0')} */}
                    {/* {resultData[questionNo]?.question_response?.question?.correct_score}
                    </span>
                  </div>
                </div> */}
                  </div>
                  <div className="d-flex justify-content-between w-100 mt-2 mb-2" style={{ position: "relative" }}>
                    <div className="d-flex">
                      <div>
                        <span className="subTitle2">
                          {studentResultData?.assessment?.subject_id?.name}
                        </span>
                        &nbsp;
                        <span>|</span> &nbsp;
                        {/* <span className="subTitles3">Scheduled On</span> &nbsp;
                        <span className="subTitle2">
                          {timeHelper(studentResultData?.assessment?.deadline)}
                          {console.log("studentResultData", studentResultData)}
                          {assessmentDateHelper(studentResultData?.assessment?.schedule_date)}{" - "}
                          {assessmentTimeHelper(studentResultData?.assessment?.schedule_time)}
                        </span> */}
                        &nbsp;
                      </div>
                      <div>
                        <span>|</span> &nbsp;
                        <span className="subTitles3">Submitted</span> &nbsp;
                        <span className="subTitle2">
                          {timeHelper(studentResultData?.submitted_on)}
                        </span>
                        &nbsp;
                      </div>
                      <div>
                        <span>|</span> &nbsp;
                        <span className="subTitles3">Evaluated on</span> &nbsp;
                        <span className="subTitle2">
                          {timeHelper(studentResultData?.evaluation_on)}
                        </span>
                        &nbsp;
                      </div>
                      {
                        completeAss?.checkAdaptive && (< span style={{ padding: "7px 12px", position: "absolute", top: "-6px", left: "630px", borderRadius: "6px" }}>
                          <img src="/images/adaptiveImg.png" alt="img" style={{ width: "120px" }} />
                        </span>)
                      }
                      {
                        completeAss?.checkAutoEvalution && (< span style={{ padding: "7px 12px", position: "absolute", top: "-26px", left: "630px", borderRadius: "6px" }}>
                          <img src="/images/auto-eva.png" alt="img" style={{ width: "90px" }} />
                        </span>)
                      }
                    </div>
                    {/* <div className="subTitle2">
                  Questions: {questionNo + 1}/{resultData?.length}
                </div> */}
                  </div>
                </div>
                <div style={{ fontSize: "18px", fontWeight: "500", margin: "15px 0px" }}>{studentResultData?.assessment?.description}</div>
                <div className="mt-3 d-flex gap-2" style={{ overflowX: "auto" }}>
                  {resultData?.length > 0 &&
                    resultData?.map((item, index) => (
                      <div
                        onClick={(e) => setQuestionNo(index)}
                        className={
                          questionNo > index
                            ? "QuestionActiveNo"
                            : "QuestionNoNonActive"
                        }
                        style={{
                          borderColor: item.question_response.question.is_mandatory
                            ? "#AC1616"
                            : questionNo === index
                              ? "#F99933"
                              : questionNo > index
                                ? "#F77F00"
                                : "#668598",
                          color:
                            questionNo === index
                              ? "#F99933"
                              : questionNo > index
                                ? "#F77F00"
                                : "#668598",
                          backgroundColor:
                            questionNo > index ? "#FEF2E5" : "transparent",
                          minWidth: "30px",
                        }}
                      >
                        Q{index + 1}
                      </div>
                    ))}
                </div>
                <div className="mt-4 allquestionTypesContainer row" style={{ overflow: "scroll" }}>
                  {/* <div className='Question'>Q1. .?</div> */}
                  {/* <div className='Question'>Q{questionNo + 1}.&nbsp; {list[questionNo].title}</div> */}
                  {/* <div className='Question'>{list[questionNo].dec}</div> */}

                  {/* {list[questionNo].type === "Img Type" && (
                <ImgType questionNo={questionNo + 1} />
              )}
              {list[questionNo].type === "Video Type" && (
                <VideoType questionNo={questionNo + 1} />
              )}
              {list[questionNo].type === "TextArea Type" && (
                <TextareaType questionNo={questionNo + 1} />
              )}
              {list[questionNo].type === "Pdf Type" && (
                <PdfType questionNo={questionNo + 1} />
              )}
              {list[questionNo].type === "Checkbox Type" && (
                <CheckBoxType questionNo={questionNo + 1} />
              )}
              {list[questionNo].type === "Upload Type" && (
                <SubmisshionByUpload questionNo={questionNo + 1} />
              )} */}

                  <div className={`${studentResultData.assessment.isAdaptive ? "col-8" : "col-12"}`} >
                    {!resultData[questionNo]?.question_response?.question?.type
                      ?.is_manually_graded ? (
                      <CheckBoxType
                        questionNo={questionNo + 1}
                        response={resultData[questionNo]}
                        isAdaptiveCheck={studentResultData.assessment.isAdaptive}
                      />
                    ) : (
                      <SubmisshionByUpload
                        questionNo={questionNo + 1}
                        response={resultData[questionNo]}
                        isAdaptiveCheck={studentResultData.assessment.isAdaptive}
                      />
                    )}
                  </div>
                  {studentResultData.assessment.isAdaptive && (<div className="col-4">
                    <div style={{ display: "flex", marginTop: "42px" }}>
                      <VerticalProgBar
                        title="Difficulty"
                        levels={difficultyLevels}
                        progress={difficulty * 20}
                      />
                      <VerticalProgBar
                        title="Skills"
                        levels={skillsLevels}
                        progress={skillsValue * 16.67}
                      />
                    </div>
                  </div>)
                  }
                  <div>


                    <div className="d-flex gap-2 justify-content-end nextBtnContainer">
                      {questionNo >= 1 && (
                        <button
                          className="PreviousBtnQue"
                          onClick={(e) => setQuestionNo(questionNo - 1)}
                        >
                          Previous
                        </button>
                      )}

                      {resultData?.length > questionNo + 1 && (
                        <button
                          className="nextBtnQue"
                          onClick={(e) => setQuestionNo(questionNo + 1)}
                        >
                          Next
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {
                openGraphPopup && (
                  <AdaptiveEvalutionGraph studentResultData={studentResultData} chartData={chartData} studentMarksDetails={studentMarksDetails} setOpenGraphPopup={setOpenGraphPopup} />
                )
              }
            </div>
          ) : (
            <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
              <span>Assessment Not Found</span>
            </div>
          )}
    </>
  );
}
